import { inject, Injectable } from '@angular/core';
// eslint-disable-next-line no-restricted-imports -- shared-auth cannot depend on the higher-level shared-services capability layer.
import { FeatureFlagsService } from '@libs/shared/common';
import { CustomerBlockingStatusBlocked, CustomerModel } from '@libs/account/models';
import { ConnectionParams } from '@libs/shared/models';
import { Observable } from 'rxjs';
import { CustomerConnectorService } from '../util/customer-connector.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerRepositoryService {
  private readonly connector: CustomerConnectorService = inject(CustomerConnectorService);
  private readonly featureFlagsService: FeatureFlagsService = inject(FeatureFlagsService);

  public readAll(): Observable<CustomerModel[]> {
    return this.connector.connect('customers');
  }

  public getByNumber(customerId: string): Observable<CustomerModel> {
    return this.connector.connect('customerByNumber', {
      pathParams: {
        customerNumber: customerId,
      },
    });
  }

  public update(customerNumber: string, data: Partial<CustomerModel>): Observable<CustomerModel> {
    const params: ConnectionParams = {
      payload: data,
      pathParams: { customerNumber },
    };

    return this.connector.connect('customerUpdate', params);
  }

  public isCustomerBlocked(customer: CustomerModel | undefined): boolean {
    if (!this.featureFlagsService.blockingCustomersEnabled()) {
      return false;
    }

    if (!customer) {
      return false;
    }

    return CustomerBlockingStatusBlocked.includes(customer.blockingStatus);
  }
}
